// extracted by mini-css-extract-plugin
export default {"lds-ellipsis":"style_lds-ellipsis__Bo75A","lds-ellipsis1":"style_lds-ellipsis1__pQWzl","lds-ellipsis2":"style_lds-ellipsis2__OIvQi","lds-ellipsis3":"style_lds-ellipsis3__8SvX1"};